import {
    IonPage, IonContent, IonInput, IonTitle
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import {getQueryVariable} from "../../../../utils/commonFunction";
import {getTokenParam} from "../../Service";
import cookieUtil from "../../../../utils/cookieUtil";
import {jumpKeFu} from "../../../../utils/common";
import {getUserInfo} from "./Service";


class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showTipModal: false,
            showDetail: false,
            showPageOne: true,
            token: null,
            timeSpan: new Date().getTime()
        }
    }

    componentDidMount() {
        let pms = getQueryVariable('pm');
        if (pms != null) {
            this.getTokenParams(pms);
        } else if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")});
            if (!cookieUtil.has("userInfo")) {
                this.queryUserInfo();
            }
        }
    }

    getTokenParams = (pms) => {
        let params = {
            pagePm: pms
        }
        getTokenParam(params, '?pagePm=' + pms).then(ret => {
            if (ret.code === '10000') {
                console.log('111')
                cookieUtil.put("access_token", ret.data.accessToken);
                console.log("phoneIndex=" + cookieUtil.get("access_token"));
                this.setState({token: ret.data.accessToken});
                this.queryUserInfo();
            }
        })
    }

    queryUserInfo = () => {
        if (cookieUtil.has("access_token")) {
            let param = {
                "access_token": cookieUtil.get("access_token")
            }
            getUserInfo(param).then(res => {
                if (res.code === '10000') {
                    cookieUtil.putExpire("userInfo", JSON.stringify(res.data))
                }
            }).catch(err => {
                console.log(err);
            });

        }
    }

    copyText = (copyText) => {
        console.log(copyText);
        navigator.clipboard.writeText(copyText)
        alert("文本已复制成功！");
    }

    render() {

        const {showPageOne, timeSpan} = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont">
                        <div className="news-head">
                            <a className={showPageOne ? "on" : ""}
                               onClick={() => this.setState({showPageOne: true})}>账号问题</a>
                            <a className={showPageOne ? "" : "on"}
                               onClick={() => this.setState({showPageOne: false})}>信息进度查询</a>
                        </div>
                        <div className={showPageOne ? "help-list" : "dn"}>
                            <a href={"/phone/phoneBind?t=" + timeSpan}>
                                <img src={require("../../../images/member/kefu/phone/link_icon01.png")}/>
                                <span>绑定手机</span>
                            </a>
                            <a href="/phone/changePassword">
                                <img src={require("../../../images/member/kefu/phone/link_icon02.png")}/>
                                <span>修改密码</span>
                            </a>
                            <a href="/phone/accountLost">
                                <img src={require("../../../images/member/kefu/phone/link_icon03.png")}/>
                                <span>账号挂失</span>
                            </a>
                            <a href="/phone/accountAppeal">
                                <img src={require("../../../images/member/kefu/phone/link_icon04.png")}/>
                                <span>账号申诉</span>
                            </a>
                            <a href="/phone/accountTheft">
                                <img src={require("../../../images/member/kefu/phone/link_icon05.png")}/>
                                <span>账号被盗</span>
                            </a>
                            <a href="/phone/gameException">
                                <img src={require("../../../images/member/kefu/phone/link_icon06.png")}/>
                                <span>游戏异常</span>
                            </a>
                            <a href="/phone/suggest">
                                <img src={require("../../../images/member/kefu/phone/link_icon07.png")}/>
                                <span>投诉建议</span>
                            </a>
                            <a href="/phone/accountCancellation">
                                <img src={require("../../../images/member/kefu/phone/link_icon08.png")}/>
                                <span>账号注销</span>
                            </a>
                        </div>
                        <div className={showPageOne ? "dn" : "help-list"}>
                            <a href="/phone/realNameAuthen">
                                <img src={require("../../../images/member/kefu/phone/link_icon01_1.png")}/>
                                <span>实名认证</span>
                            </a>
                            <a href="/phone/rechargeRecord">
                                <img src={require("../../../images/member/kefu/phone/link_icon02_2.png")}/>
                                <span>充值记录</span>
                            </a>
                            {/*<a href="#1">*/}
                            {/*    <img src={require("../../../images/member/kefu/phone/link_icon03_3.png")}/>*/}
                            {/*        <span>账号绑定</span>*/}
                            {/*</a>*/}
                            <a href="/phone/appealProgress">
                                <img src={require("../../../images/member/kefu/phone/link_icon04_4.png")}/>
                                <span>申诉进度查询</span>
                            </a>
                        </div>
                        <div className="service_box pr">
                            <a className="service" href="/phone/refundTutelage">
                                <img src={require("../../../images/member/kefu/phone/title.png")}/></a>
                            <div className="phone">
                                <span className="phone_icon">
                                    <img src={require("../../../images/member/kefu/phone/iphone_icon.png")}/>
                                </span>
                                <a onClick={() => this.copyText("400-885-2091")}>400-885-2091</a>
                            </div>
                            <div className="phone"><span className="phone_icon"><img
                                src={require("../../../images/member/kefu/phone/email_icon.png")}/></span>
                                <a onClick={() => this.copyText("kefu@91y.com")}>kefu@91y.com</a>
                            </div>
                            <a onClick={() => jumpKeFu(this.state.token)} className="service_icon">
                                <img src={require("../../../images/member/kefu/phone/service_btn.png")}/>
                            </a>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(Index);
